import { selectors, actionCreators, sliceKeys } from '../../model';
import { ReactComponent as TableIcon } from '../../../../resource/TableWithMonitorIcon.svg';

export const types = {
  desk: 'desk',
};

export const props = {
  [types.desk]: {
    key: types.desk,
    emptyDesc: 'Нет добавленных столов',
    activeIndexSelector: selectors[sliceKeys.desks].selectActiveIndex,
    changeAction: actionCreators[sliceKeys.desks].activeDeskIndexChanged,
    icon: TableIcon,
  },
};
